import {
  BookingSpaceInvoiceSummaryType,
  UserBookingDetailsQuery,
} from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import InvoiceRowItem from './InvoiceRowItem';

function InvoiceLineText({
  summary,
}: {
  summary: UserBookingDetailsQuery['booking']['invoiceSummary'][number];
}) {
  const createdFormatted = DateTime.fromISO(summary.created).toFormat(
    'dd/MM/yyyy',
  );

  switch (summary.type) {
    case BookingSpaceInvoiceSummaryType.CREDIT_USED:
      return `Deposit paid with credits on ${createdFormatted}`;
    case BookingSpaceInvoiceSummaryType.CREDIT_ISSUED:
      return `Credit returned on ${createdFormatted}`;
    case BookingSpaceInvoiceSummaryType.BALANCE_DUE:
      return `Balance due on ${createdFormatted}`;
    case BookingSpaceInvoiceSummaryType.CANCELLATION:
      return `${summary.numberOfSpaces} cancelled on ${createdFormatted}`;
    case BookingSpaceInvoiceSummaryType.BALANCE_PAYMENT:
      return `Balance payment on ${createdFormatted} ${summary.card ? `(${summary.card?.cardType} - ${summary.card?.lastFourDigits})` : ''}`;
    case BookingSpaceInvoiceSummaryType.BALANCE_REFUND:
      return `Refund on ${createdFormatted} ${summary.card ? `(${summary.card?.cardType} - ${summary.card?.lastFourDigits})` : ''}`;
    case BookingSpaceInvoiceSummaryType.DISCRETIONARY_CHANGE:
      return `Discretionary change on ${createdFormatted}`;
    case BookingSpaceInvoiceSummaryType.DEPOSIT_PAYMENT:
      return `Deposit payment on ${createdFormatted} ${summary.card ? `(${summary.card?.cardType} - ${summary.card?.lastFourDigits})` : ''}`;
    case BookingSpaceInvoiceSummaryType.FULL_PAYMENT:
      return `Full payment on ${createdFormatted} ${summary.card ? `(${summary.card?.cardType} - ${summary.card?.lastFourDigits})` : ''}`;
    case BookingSpaceInvoiceSummaryType.TOTAL_BOOKING_VALUE:
    default:
      return null;
  }
}

export default function TransactionsSection({
  booking,
}: {
  booking: Pick<UserBookingDetailsQuery['booking'], 'invoiceSummary'>;
}) {
  const summary = booking.invoiceSummary.filter(
    (line) =>
      line.type === BookingSpaceInvoiceSummaryType.BALANCE_PAYMENT ||
      line.type === BookingSpaceInvoiceSummaryType.BALANCE_REFUND ||
      line.type === BookingSpaceInvoiceSummaryType.DEPOSIT_PAYMENT ||
      line.type === BookingSpaceInvoiceSummaryType.FULL_PAYMENT ||
      line.type === BookingSpaceInvoiceSummaryType.CREDIT_USED ||
      line.type === BookingSpaceInvoiceSummaryType.CREDIT_ISSUED,
  );

  return (
    <>
      <InvoiceRowItem
        amountZD={0}
        currency={'GBP'}
        lineText={'Transactions'}
        trClassName="border-bottom border-top "
        className="fw-bold"
        hideAmount
      />
      {summary.map((invoice) => {
        return (
          <InvoiceRowItem
            key={invoice.created}
            amountZD={invoice.amount.amountZD}
            currency={invoice.amount.currency}
            lineText={<InvoiceLineText summary={invoice} />}
            isIndented
            className="small"
          />
        );
      })}
    </>
  );
}
